import { Component, Input } from '@angular/core';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-all-data-view-header',
  templateUrl: './all-data-view-header.component.html',
  styleUrl: './all-data-view-header.component.scss'
})
export class AllDataViewHeaderComponent {

  @Input() heading: string = "ﺑﻮاﺑﺔ اﻟﻤﻌﺮﻓﺔ ";
  @Input() sub_heading: string = "";
  @Input() breadcrumbs?: MenuItem[];
  @Input() type?: string = '';
  @Input() datatype: string = 'service'

}
